<div class="page-wrapper-container">
  @if (operatingMessages) {
    <div class="m-d div-operatingMessages">
      <nz-alert nzBanner nzType="info" [nzMessage]="messageTemplate" nzShowIcon></nz-alert>
      <ng-template #messageTemplate>
        <div [innerHTML]="operatingMessages"></div>
      </ng-template>
    </div>
  }

  <ng-content></ng-content>
</div>
